import React from 'react';
import { motion } from 'framer-motion';
import { FaCommentDots, FaChartLine, FaMedal } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const HowItWorks = () => {
  const { t } = useTranslation();

const steps = [
  {
    number: 1,
      title: t('howItWorks.steps.0.title'),
      description: t('howItWorks.steps.0.description'),
    icon: <FaCommentDots />
  },
  {
    number: 2,
      title: t('howItWorks.steps.1.title'),
      description: t('howItWorks.steps.1.description'),
    icon: <FaChartLine />
  },
  {
    number: 3,
      title: t('howItWorks.steps.2.title'),
      description: t('howItWorks.steps.2.description'),
    icon: <FaMedal />
  }
];

  return (
    <section className="how-it-works">
      <div className="container">
        <motion.h2 
          className="section-title"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          {t('howItWorks.title')}
        </motion.h2>
        
        <motion.p 
          className="section-subtitle"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          {t('howItWorks.subtitle')}
        </motion.p>
        
        <div className="steps-container">
          {steps.map((step, index) => (
            <motion.div 
              key={step.number}
              className="step-item"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
            >
              <div className="step-number">
                {step.number}
                <div className="step-icon">{step.icon}</div>
              </div>
              <h3 className="step-title">{step.title}</h3>
              <p className="step-description">{step.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks; 